import { render, staticRenderFns } from "./quemsomos.vue?vue&type=template&id=2944da46"
import script from "./quemsomos.vue?vue&type=script&lang=js"
export * from "./quemsomos.vue?vue&type=script&lang=js"
import style0 from "./quemsomos.vue?vue&type=style&index=0&id=2944da46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports